/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type MediaPolicyInRegulated = typeof MediaPolicyInRegulated[keyof typeof MediaPolicyInRegulated];


export const MediaPolicyInRegulated = {
  video_audio: 'video_audio',
  audio_only: 'audio_only',
} as const;
